import { render, staticRenderFns } from "./ModuleInformationEditModal.vue?vue&type=template&id=298f0b21&scoped=true&"
import script from "./ModuleInformationEditModal.vue?vue&type=script&lang=js&"
export * from "./ModuleInformationEditModal.vue?vue&type=script&lang=js&"
import style0 from "./ModuleInformationEditModal.vue?vue&type=style&index=0&id=298f0b21&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298f0b21",
  null
  
)

export default component.exports